import './illStyles.scss'
const AwanSatu = () => {
  return (
    <div className="awanSatu">
      <img className="satuImg" src="/ill/awansatu.png" alt="ok" />
    </div>
  )
}

export default AwanSatu
